export default __webpack_public_path__ + "static/card2-mobile-5c12beda40b86c1c39e3cc5fc528ebab.png";